import React, { useState } from 'react';
import '../styles/DeviceRegistration.css';

const DeviceRegistration = ({ onClose, onDeviceAdded }) => {
  const [formData, setFormData] = useState({
    deviceType: 'water', // Default to water meter
    deviceId: '',
    location: '',
    description: '',
    email: '',
    expectedConsumption: '',
    model: 'DN25', // Default model
    address: ''
  });
  
  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const nextStep = () => {
    setStep(step + 1);
  };
  
  const prevStep = () => {
    setStep(step - 1);
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Call the parent component callback
      onDeviceAdded({
        ...formData,
        status: 'On',
        id: Math.random().toString(36).substr(2, 9) // Generate temporary ID
      });
      
      onClose();
    } catch (error) {
      console.error('Error registering device:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <div className="device-registration-overlay">
      <div className="device-registration-modal">
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Register New Device</h2>
        
        {step === 1 && (
          <form onSubmit={(e) => { e.preventDefault(); nextStep(); }}>
            <div className="form-group">
              <label>Device Type</label>
              <div className="device-type-selector">
                <div 
                  className={`device-option ${formData.deviceType === 'water' ? 'selected' : ''}`}
                  onClick={() => setFormData({...formData, deviceType: 'water'})}
                >
                  <div className="device-icon water-icon">💧</div>
                  <span>Water Meter</span>
                </div>
                <div 
                  className={`device-option ${formData.deviceType === 'electricity' ? 'selected' : ''}`}
                  onClick={() => setFormData({...formData, deviceType: 'electricity'})}
                >
                  <div className="device-icon electricity-icon">⚡</div>
                  <span>Electricity Meter</span>
                </div>
              </div>
            </div>
            
            {formData.deviceType === 'water' && (
              <div className="form-group">
                <label htmlFor="model">Meter Model</label>
                <select
                  id="model"
                  name="model"
                  value={formData.model}
                  onChange={handleChange}
                >
                  <option value="DN25">DN25</option>
                  <option value="DN32">DN32</option>
                  <option value="DN40">DN40</option>
                  <option value="DN50">DN50</option>
                  <option value="DN100">DN100</option>
                </select>
              </div>
            )}
            
            <div className="form-group">
              <label htmlFor="deviceId">Device ID/Serial Number *</label>
              <input 
                type="text" 
                id="deviceId" 
                name="deviceId" 
                value={formData.deviceId} 
                onChange={handleChange} 
                required 
                placeholder="Enter the ID or serial number on your device"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="location">Installation Location *</label>
              <input 
                type="text" 
                id="location" 
                name="location" 
                value={formData.location} 
                onChange={handleChange} 
                required 
                placeholder="Where is this device installed? (e.g., Kitchen, Backyard)"
              />
            </div>
            
            <div className="form-actions">
              <button type="submit" className="next-button">Continue</button>
            </div>
          </form>
        )}
        
        {step === 2 && (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="description">Device Description</label>
              <input 
                type="text" 
                id="description" 
                name="description" 
                value={formData.description} 
                onChange={handleChange} 
                placeholder="Brief description of this device"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="address">Installation Address</label>
              <input 
                type="text" 
                id="address" 
                name="address" 
                value={formData.address} 
                onChange={handleChange} 
                placeholder="Full address where this device is installed"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="email">Notification Email *</label>
              <input 
                type="email" 
                id="email" 
                name="email" 
                value={formData.email} 
                onChange={handleChange} 
                required 
                placeholder="Email to receive device alerts"
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="expectedConsumption">Expected Daily Consumption</label>
              <div className="input-with-unit">
                <input 
                  type="number" 
                  id="expectedConsumption" 
                  name="expectedConsumption" 
                  value={formData.expectedConsumption} 
                  onChange={handleChange} 
                  placeholder="Average daily usage"
                />
                <span className="unit">{formData.deviceType === 'water' ? 'L' : 'kWh'}</span>
              </div>
              <p className="form-help-text">We'll alert you if consumption exceeds this amount</p>
            </div>
            
            <div className="form-actions">
              <button type="button" onClick={prevStep} className="back-button">Back</button>
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Registering...' : 'Register Device'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default DeviceRegistration; 